<router-outlet></router-outlet>




// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer.component.html